interface EventDetailsHeaderProps {
  eventName: string;
  date: string | null;
  timeRange: string | null;
  gymName: string | null;
}

export function EventDetailsHeader({
  eventName,
  date,
  timeRange,
  gymName,
}: EventDetailsHeaderProps) {
  return (
    <>
      <p className="mt-4 text-h6">{eventName}</p>
      {date ? <p className="text-subtitle2 uppercase">{date}</p> : null}
      {timeRange ? <p className="text-subtitle2 font-light uppercase">{timeRange}</p> : null}
      {gymName ? <p className="text-subtitle2 font-light">{gymName}</p> : null}
    </>
  );
}
